import React, { useState } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import PropTypes from 'prop-types';

import WebCamIcon from './WebCamIcon';
import WebCamDrawer from './WebCamDrawer';

const WebCam = (props) => {
  const { webcam } = props;
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Marker
        longitude={webcam?.external_asset?.data?.properties?.location?.coordinates?.[0]}
        latitude={webcam?.external_asset?.data?.properties?.location?.coordinates?.[1]}
        onClick={() => setVisible(true)}
      >
        <div
          style={{
            position: 'relative',
            width: visible ? 26 : 24,
            height: visible ? 26 : 24,
            backgroundColor: '#70C029',
            borderRadius: 20,
            display: 'flex',
            justifyContent: 'center',
            border: '2px solid #fff',
            alignItems: 'center',
            transform: 'translate(-50%, -50%)', // to center over map position
            cursor: 'pointer',
          }}
        >
          <WebCamIcon
            width={visible ? 20 : 18}
            height={visible ? 20 : 18}
          />
          {visible && (
            <>
              <div
                style={{
                  position: 'absolute',
                  bottom: -5,
                  // left: '50%',
                  transform: 'rotate(45deg)',
                  width: 10,
                  height: 10,
                  borderBottom: '2px solid white',
                  borderRight: '2px solid white',
                  background: '#70C029',
                  zIndex: -1,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: -12,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 30,
                  height: 10,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: '50%',
                  filter: 'blur(3px)',
                  zIndex: -2,
                }}
              />
            </>
          )}
        </div>
      </Marker>
      {visible && (
        <WebCamDrawer
          visible={visible}
          setVisible={setVisible}
          webcam={webcam}
        />
      )}
    </>
  );
};

WebCam.propTypes = {
  webcam: PropTypes.object.isRequired,
};

export default WebCam;
